export default __webpack_public_path__ + "static/media/imgfaq.6a8cbdbe.jpg";